module.exports = __webpack_public_path__ + "images/program/clock.3472ceca.svg";